var map = {
	"./arrow.svg": "c70e",
	"./bill.svg": "b9ec",
	"./bucket.svg": "d4e5",
	"./chevron.svg": "4872",
	"./close.svg": "1469",
	"./filter.svg": "968a",
	"./map.svg": "b64bd",
	"./pause.svg": "c5f7",
	"./pdf.svg": "8eaa",
	"./play.svg": "df6a",
	"./playslide.svg": "f0e3",
	"./volume-off.svg": "1b88",
	"./volume-on.svg": "8054"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b7de";